module.exports = __webpack_public_path__ + "static/la-ventures--raph-cardona-7fb96a23763bdc321b4600a49f14f82a.mp4";